export const SCREEN_MAX_WIDTH = 468

/** Height of HeaderBar. Shared so full-bleed screens can offset behind it. */
export const HEADER_BAR_HEIGHT = '67px'
